module.exports = __webpack_public_path__ + "img/8_51.bf53f751.png";